import { render, staticRenderFns } from "./addEventV2.vue?vue&type=template&id=48299da2&scoped=true"
import script from "./addEventV2.vue?vue&type=script&lang=js"
export * from "./addEventV2.vue?vue&type=script&lang=js"
import style0 from "./addEventV2.vue?vue&type=style&index=0&id=48299da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48299da2",
  null
  
)

export default component.exports